import { render, staticRenderFns } from "./UsagePage.vue?vue&type=template&id=37924156&scoped=true"
import script from "./UsagePage.vue?vue&type=script&lang=js"
export * from "./UsagePage.vue?vue&type=script&lang=js"
import style0 from "./UsagePage.vue?vue&type=style&index=0&id=37924156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37924156",
  null
  
)

export default component.exports